import React, { FC } from 'react'
import { CellularPayPrompt } from './types'
import { Banner } from './banner'
import { PromptButton } from './dialog-parts'
import { formatMoney } from './format'
import { affectedSentence, isSuspendedStage, payableSimStage, simStageMessage } from './sim-status'

interface RestoreBannerProps {
  prompt: CellularPayPrompt
  onPay: () => void
}

// Once the paywall reports the SIMs suspended, the dates it gives (and the
// shut-off date above all) say more than the amount does.
const restoreMessage = (prompt: CellularPayPrompt): string => {
  if (isSuspendedStage(payableSimStage(prompt))) {
    return [simStageMessage(prompt), affectedSentence(prompt)].filter(Boolean).join(' ')
  }
  return (
    `Cellular service off for ${prompt.controllers} display(s). ` +
    `Restore it by paying ${formatMoney(prompt.amountDueUsd, prompt.currency)}.`
  )
}

// Slim, non-blocking reminder shown after the customer gave up their cellular connection.
export const RestoreBanner: FC<RestoreBannerProps> = ({ prompt, onPay }) => (
  <Banner
    message={restoreMessage(prompt)}
    tone='destructive'
  >
    <PromptButton
      onClick={onPay}
      variant='textPrimary'
    >
      Pay Now
    </PromptButton>
  </Banner>
)
